import { useQuery, UseQueryResult } from "react-query"
import CarrotClient from "lib/carrot-api"
import Settings from "utils/CarrotConfig"
import ResponseError from "utils/ResponseError"
import { Company } from "types/Company"
import { RetryConfig } from "utils/ErrorHandling"
const client = new CarrotClient(Settings.CARROT_BACKEND_URL)
const ENDPOINT = "GetCompany"

export default function useCompany(companyId: number): UseQueryResult<Company, ResponseError> {
  return useQuery<Company, ResponseError>([ENDPOINT, companyId], () => client.getCompany(companyId), {
    ...RetryConfig
  })
}
